import { serviceDescriptor } from "@/config/services";

/**
 * Fondo e icono de un servicio.
 *
 * Antes era un `switch` propio, copy-paste del de `StatusMessage`, y solo se editó
 * uno de los dos: aquí Bus quedó con el icono `monetization_on` (un icono de
 * dinero) mientras allá tenía `directions_bus`. Como este composable alimenta
 * `ServiceIcon` y `usePoliciesTab`, el icono equivocado se veía en la pestaña de
 * políticas y en el resumen de CEF.
 *
 * Ahora los dos leen del registry (`src/config/services.ts`), así que no pueden
 * volver a divergir.
 */
export const useServiceMedia = (serviceName: string) => {
  const service = serviceDescriptor(serviceName);

  return {
    backgroundImage: service.backgroundImage,
    serviceIcon: service.icon,
  };
};
